export default "__VITE_ASSET__B$xwO1ih__"